<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <div v-else>
            <div>
                <b-button :variant="mode == 1 ? 'dark' : 'light'" class="mr-2" @click="switchMode(1)">
                    LM Scan
                </b-button>
                <b-button :variant="mode == 2 ? 'dark' : 'light'" class="mr-2" @click="switchMode(2)">
                    LM Retro
                </b-button>
                <b-button :variant="mode == 3 ? 'dark' : 'light'" class="mr-2" @click="switchMode(3)">
                    Perhiasan
                </b-button>
                <b-button :variant="mode == 4 ? 'dark' : 'light'" @click="switchMode(4)">
                    Buyback
                </b-button>
            </div>
            <b-card class="mt-3">
                <h5 class="mb-0">{{ getModeName }}</h5>
                <div class="mb-3" v-if="mode === 1">
                    <div class="text-right">
                        <b-button variant="primary" class="mr-2" @click="showPriceLog">History Harga Emas</b-button>
                        <b-button variant="success" class="mr-2" @click="exportExcel">Export Data</b-button>
                        <b-button variant="success" class="mr-2" @click="openModalImport">Import Data</b-button>
                    </div>
                    <div class="mt-3">
                        <b-row class="d-flex align-items-center">
                            <b-col md="4">
                                <b-form-group label="Merk">
                                    <multiselect v-model="brand" :allow-empty="false" label="name"
                                        track-by="id" @input="getLMScanTypes" :internal-search="true" :options="brands"/>
                                </b-form-group>
                            </b-col>
                            <b-col md="4">
                                <b-form-group label="Tipe">
                                    <multiselect v-model="type" :disabled="!brand" :allow-empty="false" label="name"
                                        track-by="id" :internal-search="true" :options="types" />
                                </b-form-group>
                            </b-col>
                            <b-col md="4">
                                <b-button variant="primary" class="mt-2" @click="onSearchLMScanItems">
                                    <i class="fa fa-search" />
                                    Cari
                                </b-button>
                            </b-col>
                        </b-row>
                    </div>
                </div>
                <hr />
                <b-row class="mb-3" v-if="mode !== 1">
                    <b-col md="6">
                        <div class="small text-muted">
                            Perubahan terakhir pada {{ $helper.parseDate(getLastUpdated.at) }}, {{ $helper.parseHourMinute(getLastUpdated.at) }}<br />
                            oleh {{ getLastUpdated.by }}
                        </div>
                    </b-col>
                    <b-col md="6" class="text-right">
                        <b-button variant="primary" @click="showPriceLog">
                            {{ mode === 4 ? 'History Harga Buyback' : 'History Harga Emas' }}
                        </b-button>
                    </b-col>
                </b-row>

                <!-- LM Scan Table -->
                <div v-if="mode == 1" class="mb-3">
                    <b-table v-if="mode == 1" responsive bordered no-local-sorting
                        :fields="scanFields"
                        :items="scanItems"
                        :busy="isBusy"
                    >
                        <template v-slot:cell(brand_name)="row">
                            {{ row.item.brand_name }}
                        </template>
                        <template v-slot:cell(type_name)="row">
                            {{ row.item.type_name }}
                        </template>
                        <template v-slot:cell(price)="row">
                            Rp.{{ row.item.price }}
                        </template>
                        <template v-slot:cell(updated_by)="row">
                            {{ row.item.updated_by || row.item.created_by || '-' }}
                        </template>
                        <template v-slot:cell(updated_at)="row">
                            {{ row.item.updated_at ? $helper.parseDate(row.item.updated_at) + ', ' + $helper.parseHourMinute(row.item.updated_at) : (row.item.created_at ? $helper.parseDate(row.item.created_at) + ', ' + $helper.parseHourMinute(row.item.created_at) : '-') }}
                        </template>
                        <template v-slot:cell(action)="row">
                            <div style="width: 40px; margin-top: 2px">
                                <b-button size="sm" variant="primary" v-b-tooltip.hover title="Edit" @click="editItem(row.item)">
                                    <i class="fa fa-edit"></i>
                                </b-button>
                            </div>
                        </template>
                    </b-table>
                    <PageSizer
                        :totalRows="totalRows"
                        :page="currentPage"
                        :options="tableOptions"
                        @limit-change="onLimitChange"
                        @page-change="onPageChange"
                    />
                </div>

                <!-- LM Retro / Perhiasan / Buyback Single Price -->
                <div v-else class="mt-4">
                    <b-row>
                        <b-col md="6">
                            <h6>Harga {{ getModeName }}</h6>
                        </b-col>
                        <b-col md="4">
                            <b-input-group prepend="Rp.">
                                <b-form-input v-model="singlePrice" class="text-right" @input="sanitizePrice"></b-form-input>
                            </b-input-group>
                        </b-col>
                        <b-col md="2">
                            <b-button variant="primary" @click="openConfirmModal">
                                Update Harga
                            </b-button>
                        </b-col>
                    </b-row>
                    <div v-if="mode === 4 && buybackCurrentPhotoUrl" class="mt-3">
                        <small class="text-muted">Bukti Harga Saat Ini:</small><br />
                        <a :href="buybackCurrentPhotoUrl" target="_blank">
                            <img :src="buybackCurrentPhotoUrl" style="max-height:120px; border-radius:4px; cursor:pointer;" />
                        </a>
                    </div>
                </div>

            </b-card>
        </div>

        <b-modal id="m-edit-item" title="Edit Item" hide-footer @hidden="clearBuybackPhoto">
            <b-form-group label="Brand">
                <b-form-input disabled v-model="editedItem.brand_name"></b-form-input>
            </b-form-group>
            <b-form-group label="Type">
                <b-form-input disabled v-model="editedItem.type_name"></b-form-input>
            </b-form-group>
            <b-form-group label="Price">
                <b-input-group prepend="Rp.">
                    <b-form-input v-model="editedItem.price" class="text-right" @input="sanitize(editedItem, 'price')"></b-form-input>
                </b-input-group>
            </b-form-group>
            <div v-if="buybackPhotoPreview" class="mb-2">
                <small class="text-muted">Preview Foto:</small><br />
                <img :src="buybackPhotoPreview" style="max-height:120px; border-radius:4px;" />
            </div>
            <b-form-group description="Wajib diisi. Upload foto sebagai bukti harga.">
                <template #label>Bukti Harga <span style="color:red;">*</span></template>
                <input
                    type="file"
                    ref="scanPhotoInput"
                    style="display:none"
                    accept="image/jpeg,image/png"
                    @change="onBuybackPhotoSelected"
                />
                <b-button variant="outline-primary" size="sm" @click="$refs.scanPhotoInput.click()">
                    <i class="fa fa-upload mr-1" /> Pilih Foto Bukti
                </b-button>
                <b-button v-if="buybackPhotoFile" variant="outline-danger" size="sm" class="ml-2" @click="clearBuybackPhoto">
                    <i class="fa fa-times" />
                </b-button>
            </b-form-group>
            <div class="text-right mt-3">
                <b-button variant="secondary" class="mr-2" @click="$bvModal.hide('m-edit-item')">
                    Batal
                </b-button>
                <b-button variant="primary" :disabled="isSubmitting || isUploadingPhoto" @click="saveEditedItem">
                    {{ isUploadingPhoto ? 'Mengupload...' : isSubmitting ? 'Menyimpan...' : 'Simpan' }}
                </b-button>
            </div>
        </b-modal>

        <b-modal id="m-confirm-price" title="Konfirmasi Update Harga" centered no-close-on-backdrop no-close-on-esc hide-footer @hidden="clearBuybackPhoto">
            <p>Ubah harga <strong>{{ getModeName }}</strong> menjadi <strong>Rp. {{ singlePrice }}</strong>?</p>
            <div>
                <div v-if="buybackPhotoPreview" class="mb-2">
                    <small class="text-muted">Preview Foto:</small><br />
                    <img :src="buybackPhotoPreview" style="max-height:120px; border-radius:4px;" />
                </div>
                <b-form-group description="Wajib diisi. Upload foto sebagai bukti harga.">
                    <template #label>Bukti Harga <span style="color:red;">*</span></template>
                    <input
                        type="file"
                        ref="buybackPhotoInput"
                        style="display:none"
                        accept="image/jpeg,image/png"
                        @change="onBuybackPhotoSelected"
                    />
                    <b-button variant="outline-primary" size="sm" @click="$refs.buybackPhotoInput.click()">
                        <i class="fa fa-upload mr-1" /> Pilih Foto Bukti
                    </b-button>
                    <b-button v-if="buybackPhotoFile" variant="outline-danger" size="sm" class="ml-2" @click="clearBuybackPhoto">
                        <i class="fa fa-times" />
                    </b-button>
                </b-form-group>
            </div>
            <div class="text-right mt-3">
                <b-button variant="secondary" class="mr-2" @click="$bvModal.hide('m-confirm-price')">
                    Batal
                </b-button>
                <b-button variant="primary" :disabled="isSubmitting || isUploadingPhoto" @click="updateSinglePrice">
                    {{ isUploadingPhoto ? 'Mengupload...' : isSubmitting ? 'Menyimpan...' : 'Ya, Update' }}
                </b-button>
            </div>
        </b-modal>

        <b-modal id="m-download" title="Download excel harga emas" centered no-close-on-backdrop no-close-on-esc hide-footer>
            <div v-if="status == 0">
                Menyiapkan data...
            </div>
            <div v-else-if="status ==-1">
                Gagal mengambil data. Silakan coba lagi.
            </div>
            <div v-else>
                Data sudah siap. Silakan klik tombol di bawah ini untuk mengunduh file excel.
                <br />
                <a :href="$BASE_FILE_PATH + path" download>
                    <b-button variant="primary" class="mt-2">
                        <i class="fa fa-download mr-2" /> Download Excel
                    </b-button>
                </a>
            </div>
        </b-modal>

        <b-modal id="m-upload" title="Upload excel harga emas" centered no-close-on-backdrop no-close-on-esc hide-footer>
            <b-form-file v-model="fileUpload" :state="Boolean(fileUpload)" placeholder="Pilih file excel" drop-placeholder="Tarik dan lepas file disini" accept=".xlsx, .xls" />
            <b-button variant="primary" class="mt-2" @click="importExcel" :disabled="!fileUpload || isSubmitting">
                <i class="fa fa-upload mr-2" v-if="!isSubmitting" />
                {{ isSubmitting ? 'Mengupload...' : 'Unggah' }}
            </b-button>
        </b-modal>

        <b-modal id="m-price-log" size="lg" :title="mode === 4 ? 'History Harga Buyback' : 'History Harga Emas'" centered no-close-on-backdrop no-close-on-esc hide-footer>
            <b-row class="align-items-center mb-3">
                <b-col md="6">
                    <b-form-group label="Dari Tanggal" class="font-weight-bold">
                        <b-form-input
                            type="date"
                            v-model="goldPriceLog.startDate"
                            placeholder="Dari Tanggal"
                        />
                    </b-form-group>
                </b-col>
                <b-col md="6">
                    <b-form-group label="Sampai Tanggal" class="font-weight-bold">
                        <b-form-input
                            type="date"
                            v-model="goldPriceLog.endDate"
                            placeholder="Sampai Tanggal"
                        />
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row v-if="mode == 1">
                <b-col md="6">
                    <b-form-group label="Brand" class="font-weight-bold">
                        <multiselect
                            v-model="goldPriceLog.brand"
                            :options="goldPriceLog.optBrands"
                            :disabled="isFetching"
                            :allow-empty="true"
                            track-by="id"
                            label="name"
                            class="font-weight-normal"
                            :internal-search="true"
                            placeholder="Pilih Brand"
                            @input="getTypes"
                        />
                    </b-form-group>
                </b-col>
                <b-col md="6">
                    <b-form-group label="Tipe" class="font-weight-bold">
                        <multiselect
                            v-model="goldPriceLog.type"
                            :options="goldPriceLog.optTypes"
                            :disabled="isFetching || !goldPriceLog.brand"
                            :allow-empty="true"
                            label="name"
                            track-by="id"
                            class="font-weight-normal"
                            :internal-search="true"
                            placeholder="Pilih Tipe"
                        />
                    </b-form-group>
                </b-col>
            </b-row>
            <div class="text-right">
                <b-button variant="secondary" class="mr-2" @click="resetFilter">
                    Reset
                </b-button>
                <b-button variant="primary" @click="getHistoryPrices(1)">
                    <b-spinner v-if="isSubmitting" small />
                    <i class="fa fa-search" aria-hidden="true" v-else /> Cari
                </b-button>
            </div>
            <b-table class="my-4" hover bordered show-empty :busy="goldPriceLog.isBusy" :items="goldPriceLog.items" :fields="priceLogFields" responsive>
                <template v-slot:empty>
                    Tidak ada data history
                </template>
                <template v-slot:cell(date)="row">
                    <div class="d-flex flex-column">
                        {{ $helper.parseDate(row.item.created_at) }} - {{ $helper.parseHourMinute(row.item.created_at) }}
                        <span class="small">{{ row.item.created_by }}</span>
                    </div>
                </template>
                <template v-slot:cell(price_before)="row">
                    Rp. {{ $helper.formatThousand(row.item.price_before) }}
                </template>
                <template v-slot:cell(price_after)="row">
                    Rp. {{ $helper.formatThousand(row.item.price_after) }}
                </template>
                <template v-slot:cell(photo)="row">
                    <a v-if="row.item.photo_url" :href="row.item.photo_url" target="_blank">
                        <img :src="row.item.photo_url" style="max-height:60px; border-radius:4px; cursor:pointer;" />
                    </a>
                    <span v-else class="text-muted small">-</span>
                </template>
            </b-table>
            <PageSizer
                :totalRows="goldPriceLog.totalRows"
                :page="goldPriceLog.currentPage"
                :options="goldPriceLog.options"
                @limit-change="onLimitChangeHistoryPrice"
                @page-change="onPageChangeHistoryPrice"
            />
        </b-modal>

    </div>
</template>

<script>

export default {
    name: 'list-harga-emas',
    data() {
        return {
            initStatus: 0,
            isSubmitting: false,
            isFetching: false,
            status: 0,

            // 1: LM Scan, 2: LM Retro, 3: Perhiasan
            mode: 1,

            // Fields for LM Scan
            scanFields: [
                { key: "brand_name", label: "Merk Barang", sortable: false },
                { key: "type_name", label: "Tipe Barang", sortable: false },
                { key: "price", label: "Harga", sortable: false },
                { key: "updated_by", label: "Di update oleh", sortable: false },
                { key: "updated_at", label: "Di update pada", sortable: false },
                { key: "action", label: "Aksi" }
            ],

            // Items for each mode
            scanItems: [],
            isBusy: false,
            totalRows: 0,
            perPage: 10,
            currentPage: 1,
            tableOptions: [
                { value: 10, text: "10" },
                { value: 20, text: "20" },
                { value: 30, text: "30" },
                { value: 40, text: "40" },
                { value: 50, text: "50" }
            ],
            brand: null,
            type: null,
            brands: [],
            types: [],
            retroPrice: "",
            perhiasanPrice: "",
            singlePrice: "",

            // Last updated info
            lastUpdated: {
                scan: { at: "", by: "" },
                retro: { at: "", by: "" },
                perhiasan: { at: "", by: "" },
                buyback: { at: "", by: "", id: null }
            },

            buybackPhotoFile: null,
            buybackPhotoPreview: null,
            buybackCurrentPhotoUrl: null,
            isUploadingPhoto: false,

            // For edit function
            editedItem: {
                id: null,
                brand_name: "",
                type_name: "",
                price: "",
                kind_name: ""
            },

            sortBy: null,
            sortDesc: false,
            path: "",
            fileUpload: null,
            goldPriceLog: {
                startDate: null,
                endDate: null,
                brand: null,
                type: null,
                items: [],
                isBusy: false,
                totalRows: 0,
                perPage: 10,
                currentPage: 1,
                options: [
                    { value: 10, text: "10" },
                    { value: 20, text: "20" },
                    { value: 30, text: "30" },
                    { value: 40, text: "40" },
                    { value: 50, text: "50" }
                ],
                optBrands: [],
                optTypes: [],
            }
        }
    },
    computed: {
        getModeName() {
            switch(this.mode) {
                case 1: return "Logam Mulia (Scan)";
                case 2: return "Logam Mulia (Retro)";
                case 3: return "Perhiasan";
                case 4: return "Buyback";
                default: return "";
            }
        },
        getLastUpdated() {
            switch(this.mode) {
                case 1: return this.lastUpdated.scan;
                case 2: return this.lastUpdated.retro;
                case 3: return this.lastUpdated.perhiasan;
                case 4: return this.lastUpdated.buyback;
                default: return { at: "", by: "" };
            }
        },
        getKindId() {
            switch(this.mode) {
                case 1: return 251;
                case 2: return 261;
                case 3: return 257;
                default: return 251;
            }
        },
        priceLogFields() {
            const baseFields = [
                { key: "date", label: "Tanggal", sortable: false },
                { key: "price_before", label: "Harga Sebelum", sortable: false },
                { key: "price_after", label: "Harga Sesudah", sortable: false },
            ];
            const photoField = { key: "photo", label: "Bukti Harga", sortable: false };

            if (this.mode === 1) {
                return [
                    baseFields[0],
                    { key: "brand_name", label: "Merk Barang", sortable: false },
                    { key: "type_name", label: "Tipe Barang", sortable: false },
                    ...baseFields.slice(1),
                    photoField
                ];
            }

            return [...baseFields, photoField];
        }
    },
    watch: {
        priceLogFields: {
            immediate: true,
            handler(val) {
                this.goldPriceLog.fields = val;
            }
        }
    },
    methods: {
        init() {
            this.initStatus = 0;
            this.getLMScanBrands();
            this.fetchDataByMode();
        },

        fetchDataByMode() {
            switch(this.mode) {
                case 1:
                    this.getLMScanItems();
                    break;
                case 2:
                    this.getLMRetroItem();
                    break;
                case 3:
                    this.getPerhiasanItem();
                    break;
                case 4:
                    this.getBuybackItem();
                    break;
                default:
                    this.getLMScanItems();
            }
        },

        getLMScanItems(page = 1) {
            this.scanItems = [];
            this.isBusy = true;

            const params = {
                kind_id: 251,
                page: page || 1,
                per_page: this.perPage,
                brand_id: this.brand ? this.brand.id : null,
                type_id: this.type ? this.type.id : null
            };

            this.$axios.get("/gold-price", {params}).then(res => {
                let data = res.data.data;
                this.scanItems = data.items.map(item => {
                    const originalPrice = item.price;
                    const priceWithoutDecimal = parseInt(originalPrice);
                    return {
                        ...item,
                        price: this.formatCurrency(priceWithoutDecimal)
                    };
                });
                this.totalRows = data.total;
                this.initStatus = 1;
                this.isBusy = false;
            })
            .catch(() => {
                this.initStatus = -1;
                this.isBusy = false;
            });
        },

        getLMRetroItem() {
            this.$axios.get("/gold-price/261").then(res => {
                let data = res.data.data;
                this.retroPrice = data.price;
                const priceWithoutDecimal = parseInt(data.price);
                this.singlePrice = this.formatCurrency(priceWithoutDecimal);
                this.lastUpdated.retro.at = data.updated_at || data.created_at;
                this.lastUpdated.retro.by = data.updated_by || data.created_by;
                this.lastUpdated.retro.id = data.id;
                this.initStatus = 1;
            })
            .catch(() => {
                this.initStatus = -1;
            });
        },

        getPerhiasanItem() {
            this.$axios.get("/gold-price/257").then(res => {
                let data = res.data.data;
                this.perhiasanPrice = data.price;
                const priceWithoutDecimal = parseInt(data.price);
                this.singlePrice = this.formatCurrency(priceWithoutDecimal);
                this.lastUpdated.perhiasan.at = data.updated_at || data.created_at;
                this.lastUpdated.perhiasan.by = data.updated_by || data.created_by;
                this.lastUpdated.perhiasan.id = data.id;
                this.initStatus = 1;
            })
            .catch(() => {
                this.initStatus = -1;
            });
        },

        getBuybackItem() {
            this.$axios.get("gold-price/buyback").then(res => {
                let data = res.data.data;
                const priceWithoutDecimal = parseInt(data.price);
                this.singlePrice = this.formatCurrency(priceWithoutDecimal);
                this.lastUpdated.buyback.at = data.updated_at || data.created_at;
                this.lastUpdated.buyback.by = data.updated_by || data.created_by;
                this.lastUpdated.buyback.id = data.id;
                this.buybackCurrentPhotoUrl = data.photo_url || null;
                this.buybackPhotoFile = null;
                this.buybackPhotoPreview = null;
                this.initStatus = 1;
            })
            .catch(() => {
                this.initStatus = -1;
            });
        },

        switchMode(newMode) {
            if (this.mode !== newMode) {
                this.mode = newMode;
                this.clearBuybackPhoto();
                this.init();
            }
        },

        editItem(item) {
            this.editedItem = { ...item };
            this.clearBuybackPhoto();
            this.$bvModal.show("m-edit-item");
        },

        async saveEditedItem() {
            if (!this.buybackPhotoFile) {
                this.$helper.toastError(this, "Bukti harga wajib diupload.");
                return;
            }

            const payload = {
                price: this.$helper.toNumber(this.editedItem.price)
            };

            this.isSubmitting = true;

            try {
                this.isUploadingPhoto = true;
                const { presigned_url, file_path } = await this.getPresignedUrl(
                    this.buybackPhotoFile.name,
                    this.buybackPhotoFile.type,
                    'gold-price-photos',
                    String(this.editedItem.id)
                );
                await this.uploadToS3(this.buybackPhotoFile, presigned_url);
                payload.photo_url = `gold-price-photos/${String(this.editedItem.id)}/${file_path}`;
            } catch (e) {
                this.$helper.toastError(this, "Gagal mengupload foto. Silakan coba lagi.");
                this.isUploadingPhoto = false;
                this.isSubmitting = false;
                return;
            }
            this.isUploadingPhoto = false;

            this.$axios.patch(`/gold-price/${this.editedItem.id}`, payload)
                .then(() => {
                    this.$bvModal.hide("m-edit-item");
                    this.$helper.toastSuccess(this, "Berhasil update harga item!");
                    this.init();
                })
                .catch(() => {
                    this.$helper.toastError(this, "Gagal update harga item. Silakan coba lagi.");
                })
                .finally(() => {
                    this.isSubmitting = false;
                });
        },

        openConfirmModal() {
            if (!this.singlePrice) {
                this.$helper.toastError(this, "Harga tidak boleh kosong.");
                return;
            }
            this.$bvModal.show('m-confirm-price');
        },

        async updateSinglePrice() {
            const payload = {
                price: this.$helper.toNumber(this.singlePrice)
            };

            let priceId;
            if (this.mode === 2) {
                priceId = this.lastUpdated.retro.id;
            } else if (this.mode === 3) {
                priceId = this.lastUpdated.perhiasan.id;
            } else if (this.mode === 4) {
                priceId = this.lastUpdated.buyback.id;
            }

            if (!priceId) {
                this.$helper.toastError(this, "Data tidak tersedia. Silakan refresh halaman.");
                return;
            }

            if (!this.buybackPhotoFile) {
                this.$helper.toastError(this, "Bukti harga wajib diupload.");
                return;
            }

            {
                try {
                    this.isUploadingPhoto = true;
                    const { presigned_url, file_path } = await this.getPresignedUrl(
                        this.buybackPhotoFile.name,
                        this.buybackPhotoFile.type,
                        'gold-price-photos',
                        String(priceId)
                    );
                    await this.uploadToS3(this.buybackPhotoFile, presigned_url);
                    payload.photo_url = `gold-price-photos/${String(priceId)}/${file_path}`;
                } catch (e) {
                    this.$helper.toastError(this, "Gagal mengupload foto. Silakan coba lagi.");
                    this.isUploadingPhoto = false;
                    return;
                } finally {
                    this.isUploadingPhoto = false;
                }
            }

            this.isSubmitting = true;

            const url = this.mode === 4
                ? `gold-price/buyback/${priceId}`
                : `/gold-price/${priceId}`

            this.$axios.patch(url, payload)
                .then(() => {
                    this.$bvModal.hide('m-confirm-price');
                    this.$helper.toastSuccess(this, `Harga ${this.getModeName} berhasil diupdate!`);
                    if (this.mode === 2) {
                        this.getLMRetroItem();
                    } else if (this.mode === 3) {
                        this.getPerhiasanItem();
                    } else if (this.mode === 4) {
                        this.getBuybackItem();
                    }
                })
                .catch(() => {
                    this.$helper.toastError(this, "Gagal mengupdate harga. Silakan coba lagi.");
                })
                .finally(() => {
                    this.isSubmitting = false;
                });
        },
        sanitizePrice() {
            let cleaned = String(this.singlePrice).replace(/\./g, "");
            this.singlePrice = cleaned.replace(/(?!^-)[^0-9]/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        },

        sanitize(item, varName) {
            let cleaned = String(item[varName]).replace(/\./g, "");
            let res = cleaned.replace(/(?!^-)[^0-9]/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            item[varName] = res;
        },

        formatCurrency(value) {
            if (!value) return "0";
            // Convert to integer if it has decimal places
            if (typeof value === 'string' && value.includes('.')) {
                value = parseInt(value);
            }
            const number = parseFloat(value);
            return number.toLocaleString('id-ID');
        },

        onBuybackPhotoSelected(event) {
            const file = event.target.files[0];
            if (!file) return;
            this.buybackPhotoFile = file;
            this.buybackPhotoPreview = URL.createObjectURL(file);
        },

        clearBuybackPhoto() {
            this.buybackPhotoFile = null;
            this.buybackPhotoPreview = null;
            if (this.$refs.buybackPhotoInput) {
                this.$refs.buybackPhotoInput.value = '';
            }
            if (this.$refs.scanPhotoInput) {
                this.$refs.scanPhotoInput.value = '';
            }
        },

        async getPresignedUrl(fileName, fileType, directoryPath, referenceKey) {
            const response = await this.$axios.post('get-presigned-url', {
                file_name: fileName,
                file_type: fileType,
                directory_path: directoryPath,
                reference_key: referenceKey,
            });
            return response.data.data;
        },

        async uploadToS3(file, presignedUrl) {
            const res = await fetch(presignedUrl, {
                method: 'PUT',
                body: file,
                headers: { 'Content-Type': file.type },
            });
            if (!res.ok) {
                throw new Error(`S3 upload failed with status ${res.status}`);
            }
        },
        exportExcel() {
            this.$bvModal.show("m-download");
            this.status = 0;
            this.$axios.post("gold-price/export-excel", { timeout: 600000 }).then(res => {
                this.status = 1;
                this.path = res.data.data.path;
            }).catch((error) => {
                this.status = -1;
                this.$helper.parseError(this, error);
            });
        },
        openModalImport(){
            this.$bvModal.show("m-upload");
            this.fileUpload = null;
        },
        importExcel() {
            this.isSubmitting = true;
            if (!this.fileUpload) {
                this.$helper.toastError(this, "File tidak ditemukan!");
                this.isSubmitting = false;
                return;
            }
            const formData = new FormData();
            formData.append("file", this.fileUpload);
            this.$axios.post("gold-price/import-excel", formData, {
                headers: {
                    "Content-Type": "multipart/form-data"
                }
            }).then(() => {
                this.$helper.toastSuccess(this, "Berhasil mengupload file!");
                this.fileUpload = null;
                this.$bvModal.hide("m-upload");
                this.init();
            }).catch((error) => {
                this.$helper.parseError(this, error);
            }).finally(() => {
                this.isSubmitting = false;
            });
        },
        getBrands() {
            this.$axios.get(`master/brands/${this.getKindId}`).then(res => {
                this.goldPriceLog.optBrands = res.data.data
            })
        },
        getTypes() {
            this.$axios.get(`master/types/${this.goldPriceLog.brand.id}`).then(res => {
                this.goldPriceLog.optTypes = res.data.data
            })
        },
        getHistoryPrices(page = 1) {
            this.goldPriceLog.isBusy = true;
            this.goldPriceLog.items = [];
            this.goldPriceLog.currentPage = page;

            const params = {
                page: page || 1,
                per_page: this.goldPriceLog.perPage,
                start_date: this.goldPriceLog.startDate,
                end_date: this.goldPriceLog.endDate,
                item_brand_id: this.goldPriceLog.brand ? this.goldPriceLog.brand.id : null,
                item_type_id: this.goldPriceLog.type ? this.goldPriceLog.type.id : null
            };

            const logsUrl = this.mode === 4 ? 'gold-price/buyback/logs' : `gold-price/${this.getKindId}/logs`
            this.$axios.get(logsUrl, { params })
            .then(res => {
                const { items, total } = res.data.data;
                this.goldPriceLog.items = items;
                this.goldPriceLog.totalRows = total;
            })
            .catch(error => {
                this.$helper.parseError(error);
            })
            .finally(() => {
                this.goldPriceLog.isBusy = false;
            });
        },
        resetFilter() {
            this.goldPriceLog.startDate = null;
            this.goldPriceLog.endDate = null;
            this.goldPriceLog.brand = null;
            this.goldPriceLog.type = null;
        },
        onLimitChangeHistoryPrice(newPerPage) {
            this.goldPriceLog.perPage = newPerPage;
            this.getHistoryPrices(this.goldPriceLog.currentPage)
        },
        onPageChangeHistoryPrice(newPage) {
            this.goldPriceLog.currentPage = newPage;
            this.getHistoryPrices(this.goldPriceLog.currentPage);
        },
        onLimitChange(newPerPage) {
            this.perPage = newPerPage;
            this.currentPage = 1;
            this.getLMScanItems(1);

        },
        onPageChange(newPage) {
            this.currentPage = newPage;
            this.getLMScanItems(this.currentPage);
        },
        showPriceLog() {
            this.resetFilter();
            this.$bvModal.show('m-price-log');
            if (this.mode === 1) this.getBrands();
            this.getHistoryPrices(1);
        },
        getLMScanBrands() {
            this.$axios.get('master/brands/251').then((res) => {
                this.brands = res.data.data
            })
        },
        getLMScanTypes() {
            this.$axios.get(`master/types/${this.brand.id}`).then((res) => {
                this.types = res.data.data
            })
        },
        onSearchLMScanItems() {
            this.page = 1;
            this.per_page = 10;

            this.getLMScanItems(1);
        }
    },
    created() {
        this.init();
    }
}
</script>
